<div class="flex flex-col items-center space-y-4 mb-4">
    <h1 class="text-center !text-3xl !font-normal text-tertiary-900 !m-0">
        Your search is processing
    </h1>

    <app-loading-dots></app-loading-dots>

    <h2 class="text-center !text-base !font-medium text-tertiary-900">
        No action required presently.
    </h2>

    <ul class="list-disc px-5 lg:px-11 text-tertiary-900 font-normal text-base">
        <li>You may now use your device for anything else.</li>
        <li>Search may take longer in metro areas.</li>
        <li>You will be emailed upon search completion.</li>
        <li>
            Results when ready appear here, but will expire. Please act promptly
            upon receipt.
        </li>
    </ul>
</div>

<div class="flex flex-col space-y-4">
    <app-go-application-purpose-selection
        [applicationPurpose]="
            goApplicationRequestForm.controls.applicationPurpose.value
        "
        [fccRegistrationNumber]="
            goApplicationRequestForm.controls.fccRegistrationNumber.value
        "
        [callSign]="goApplicationRequestForm.controls.callSign.value"
        [applicationId]="applicationState?.salmonLogId!"
    ></app-go-application-purpose-selection>

    <app-go-parameters-summary
        [form]="goApplicationRequestForm"
        [expanded]="false"
    ></app-go-parameters-summary>

    <div
        class="flex flex-col items-center text-center space-y-1 mat-expansion-panel pt-2 pb-4 !bg-neutral-100"
    >
        <button
            id="stop-and-delete-search-button"
            class="!rounded-full w-[calc(100%-1rem)] m-2"
            type="button"
            color="primary"
            mat-stroked-button
            (click)="terminateSearch()"
            title="Stop and Delete Search"
        >
            Stop and Delete Search
        </button>
        <label
            for="stop-and-delete-search-button"
            class="text-sm font-medium text-tertiary-900 tracking-wide"
        >
            This will delete all technical data and delete this application.
        </label>
    </div>

    <div
        class="text-center text-sm font-medium text-tertiary-900 tracking-wide"
    >
        or
    </div>

    <div
        class="flex flex-col items-center text-center space-y-1 mat-expansion-panel pt-2 pb-4 !bg-neutral-100"
    >
        <button
            id="stop-and-save-search-button"
            class="!rounded-full w-[calc(100%-1rem)] m-2"
            type="button"
            color="primary"
            mat-stroked-button
            (click)="stopAndSaveSearch()"
            title="Stop and Save Search"
        >
            Stop and Save Search
        </button>
        <label
            for="stop-and-save-search-button"
            class="text-sm font-medium text-tertiary-900 tracking-wide"
        >
            Save my technical data without frequency results in
            <a
                class="text-primary-700 hover:text-primary-800"
                target="_blank"
                [routerLink]="[getDashboardRoute()]"
                >Cevo</a
            >
            under "Work in progress".
        </label>
    </div>
</div>
